import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="container-custom py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading text-lg text-background-50">
                福利视频在线
              </span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              海量高清视频资源免费在线观看平台。热门影视、综艺、短视频一网打尽，无需下载，即点即看，畅享极致视觉体验。
            </p>
          </div>

          <div>
            <h4 className="font-medium text-background-50 mb-4 text-sm">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/dianshiju" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                  热门影视
                </Link>
              </li>
              <li>
                <Link to="/category/zongyi" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                  综艺娱乐
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-background-50 mb-4 text-sm">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-background-50 mb-4 text-sm">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@fulishipin.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-phone-line text-primary-400"></i>
                <span>400-888-0000</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-map-pin-line text-primary-400"></i>
                <span>北京市朝阳区科技园区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/20">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; {new Date().getFullYear()} 福利视频在线 版权所有 | 京ICP备2025000000号-1
            </p>
            <div className="flex items-center gap-4">
              <Link to="/about" className="text-xs text-background-400 hover:text-primary-400 transition-colors">
                隐私政策
              </Link>
              <Link to="/about" className="text-xs text-background-400 hover:text-primary-400 transition-colors">
                服务条款
              </Link>
              <Link to="/about" className="text-xs text-background-400 hover:text-primary-400 transition-colors">
                免责声明
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}